import $ from 'jquery';
import Swal from 'sweetalert2';

export function initButtonUtils() {
  // --- 1. Global Import Excel ---
  $(document).on('click', '.btn-global-import', function (e) {
    e.preventDefault();
    const urlImport = $(this).data('url-import');
    const urlTemplate = $(this).data('url-template');

    if (!urlImport || !urlTemplate) {
      Swal.fire('Error', 'URL Import/Template belum diatur pada tombol ini.', 'error');
      return;
    }

    $('#formGlobalImportExcel').attr('action', urlImport);
    $('#btnDownloadTemplate').attr('href', urlTemplate);
    $('#file_excel').val('');

    const modalImportEl = document.getElementById('modalGlobalImportExcel');
    if (modalImportEl) {
      const modalImport =
        window.bootstrap.Modal.getInstance(modalImportEl) ||
        new window.bootstrap.Modal(modalImportEl);
      modalImport.show();
    }
  });

  // --- 2. Generic & Custom View Detail Handling ---
  $(document).on('click', '.btn-view-detail', async function (e) {
    e.preventDefault();
    const id = $(this).data('id');
    const url = $(this).data('url-json');
    const targetModalId = $(this).data('bs-target') || '#modalViewDetail';
    const $modal = $(targetModalId);

    // Only handle globally if url-json exists; otherwise let page-specific handlers process
    if (!url) return;
    e.stopImmediatePropagation();

    // Show loading if generic modal
    if (targetModalId === '#modalViewDetail') {
      $modal.find('.loading-spinner').removeClass('d-none');
      $modal.find('.detail-container').addClass('d-none');
      $modal.find('#detail-table-body').empty();
      const modalInstance =
        window.bootstrap.Modal.getInstance($modal[0]) || new window.bootstrap.Modal($modal[0]);
      modalInstance.show();
    }

    try {
      const response = await fetch(url);
      const result = await response.json();

      if (result.status === 'success') {
        const data = result.data;

        if (targetModalId === '#modalViewDetail') {
          // Populate Generic Modal
          const $tbody = $modal.find('#detail-table-body');
          Object.keys(data).forEach((key) => {
            let val = data[key];
            if (val === null || val === undefined) val = '-';

            // Skip internal IDs and timestamps
            if (key.startsWith('id_') || ['created_at', 'updated_at', 'deleted_at'].includes(key)) {
              return;
            }

            // Skip raw data if HTML version exists
            if (data[key + '_html']) return;

            // Format Key to Label
            let label = key.replace(/_html/g, '').replace(/_/g, ' ').toUpperCase();

            // Auto-render image if value looks like a file path and not already HTML
            if (
              typeof val === 'string' &&
              val.match(/\.(jpeg|jpg|gif|png)$/i) &&
              !val.includes('<img')
            ) {
              // Assumes base_url is available or it's a relative path from root
              // If window.location.origin is enough:
              val = `<a href="/${val}" target="_blank"><img src="/${val}" style="max-height:100px; border-radius:5px;" onerror="this.outerHTML='${val}'"/></a>`;
            }

            $tbody.append(`
                            <tr>
                                <th width="35%" class="text-muted small fw-bold text-uppercase pb-1">${label}</th>
                                <td class="fw-semibold text-dark pb-1">${val}</td>
                            </tr>
                        `);
          });

          $modal.find('.loading-spinner').addClass('d-none');
          $modal.find('.detail-container').removeClass('d-none');
        } else {
          // Populate Custom Modal (like Pegawai)
          // This uses data-view-key attribute to map data
          $modal.find('[data-view-key]').each(function () {
            const key = $(this).data('view-key');
            let val = data[key];
            if (val === null || val === undefined) val = '-';

            if ($(this).is('p, span, div, h1, h2, h3, h4, h5, h6')) {
              if (key === 'status_inspeksi') {
                $(this).removeClass('bg-success bg-warning bg-danger bg-secondary bg-primary');
                $(this).attr('style', '');
                let sText = val ? val.toString().toUpperCase() : '-';
                let sStyle = '';
                if (sText === 'WORK_ORDER') {
                  sText = 'DITUGASKAN';
                  sStyle =
                    'background-color: #e0f2fe !important; color: #0369a1 !important; border: 1px solid #bae6fd !important;';
                } else if (sText === 'TEMUAN') {
                  sText = 'BELUM DIEKSEKUSI';
                  sStyle =
                    'background-color: #fee2e2 !important; color: #b91c1c !important; border: 1px solid #fca5a5 !important;';
                } else if (sText === 'SELESAI') {
                  sText = 'SELESAI';
                  sStyle =
                    'background-color: #dcfce7 !important; color: #15803d !important; border: 1px solid #bbf7d0 !important;';
                } else if (sText === 'PROSES') {
                  sText = 'PROSES';
                  sStyle =
                    'background-color: #fef3c7 !important; color: #d97706 !important; border: 1px solid #fde68a !important;';
                } else if (sText === 'KENDALA') {
                  sText = 'KENDALA';
                  sStyle =
                    'background-color: #fce7f3 !important; color: #be185d !important; border: 1px solid #fbcfe8 !important;';
                } else {
                  sStyle =
                    'background-color: #e9ecef !important; color: #495057 !important; border: 1px solid #ced4da !important;';
                }
                $(this).text(sText).attr('style', sStyle);
              } else if (key === 'skala_prioritas') {
                $(this).removeClass('bg-success bg-warning bg-danger bg-secondary bg-primary');
                let pText = val ? val.toString().toUpperCase() : '-';
                let pStyle = '';
                if (pText === 'EMERGENSI') {
                  pText = 'PRIORITAS 1';
                  pStyle =
                    'background-color: #f8d7da !important; color: #dc3545 !important; border: 1px solid #f5c2c7 !important;';
                } else if (pText === 'URGEN' || pText === 'PERBAIKAN') {
                  pText = 'PRIORITAS 2';
                  pStyle =
                    'background-color: #ffe8d6 !important; color: #fd7e14 !important; border: 1px solid #fecba1 !important;';
                } else if (pText === 'RUTIN') {
                  pText = 'PRIORITAS 3';
                  pStyle =
                    'background-color: #fff9db !important; color: #f59f00 !important; border: 1px solid #ffe066 !important;';
                }
                $(this).text(pText).attr('style', pStyle);
              } else {
                $(this).text(val);

                // Special handling for status badges
                if ($(this).hasClass('badge')) {
                  $(this).removeClass('bg-success bg-warning bg-danger bg-secondary bg-primary');
                  let badgeColor = 'secondary';
                  const status = val ? val.toString().toUpperCase() : '-';
                  if (['SELESAI', 'AKTIF', 'NORMAL', 'OPERASI', 'TERTUTUP'].includes(status))
                    badgeColor = 'success';
                  else if (['PROSES', 'WARNING', 'SIAGA', 'URGEN', 'PERBAIKAN'].includes(status))
                    badgeColor = 'warning';
                  else if (
                    ['BATAL', 'NONAKTIF', 'RUYAM', 'BAHAYA', 'TIDAK OPERASI', 'EMERGENSI'].includes(
                      status
                    )
                  )
                    badgeColor = 'danger';

                  $(this).addClass('bg-' + badgeColor);
                }
              }
            } else if ($(this).is('a')) {
              $(this).attr('href', val).text(val);
            } else if ($(this).is('img')) {
              const prefix = $(this).data('view-image-prefix') || '';
              const defaultImg = $(this).data('default-image') || '';
              const $parentAnchor = $(this).closest('a');

              if (val && val !== '-' && val !== '') {
                const imgUrl = prefix + val;
                $(this).attr('src', imgUrl).closest('.d-none').removeClass('d-none');
                $(this).parent().show();
                if ($parentAnchor.length > 0) {
                  $parentAnchor.attr('href', imgUrl);
                }
              } else {
                if (defaultImg) {
                  $(this).attr('src', defaultImg);
                } else {
                  $(this).parent().hide();
                }
                if ($parentAnchor.length > 0) {
                  $parentAnchor.removeAttr('href');
                }
              }
            }
          });
          const modalInstance =
            window.bootstrap.Modal.getInstance($modal[0]) || new window.bootstrap.Modal($modal[0]);
          modalInstance.show();
        }
      } else {
        Swal.fire('Error', result.message || 'Gagal memuat detail data', 'error');
      }
    } catch (err) {
      Swal.fire('Error', 'Terjadi kesalahan sistem saat memuat detail', 'error');
      console.error(err);
    }
  });
}
